import _ from 'lodash';
import { useSelector } from 'react-redux';
import Select from 'components/Select';

const Categories = ({ value, onChange }) => {
  const categories = useSelector((state) => state?.categories?.data);
  return (
    <Select
      label='Category'
      options={categories}
      value={{ CatId: value || '' }}
      valueKey='CatId'
      labelKey='DisplayName'
      onChange={(CategoryID) => {
        const category = _.find(categories, (o) => o.CatId === CategoryID);
        onChange({
          category,
          product: undefined,
          colors: [],
        });
      }}
    />
  );
};

export default Categories;
